import {
  useId,
} from 'react';
import type {
  ReactNode,
  RefAttributes,
  MouseEventHandler,
  InputHTMLAttributes,
} from 'react';
import classNames from 'classnames';
import Skeleton from '@/ui/components/Skeleton';

import styles from  './Toggle.module.css';

type ToggleProps = RefAttributes<HTMLInputElement> &
                   InputHTMLAttributes<HTMLInputElement> & {
  checked?: boolean;
  loading?: boolean;
  disabled?: boolean;
  skeleton?: boolean;
  children?: ReactNode;
  onClick?: MouseEventHandler;
}

const Toggle = (props: ToggleProps) => {
  const {
    ref,
    id = useId(),
    loading = false,
    checked = false,
    skeleton = false,
    children,
    ...rest
  } = props;

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const toggleClassName = classNames({
    [styles.toggle]: true,
    [styles.checked]: checked,
    [styles.loading]: loading,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div
      ref={ref}
      className={toggleClassName}
    >
      {!skeleton && (
        <input
          {...rest}
          id={id}
          type="checkbox"
          checked={checked}
          className={styles.input}
        />
      )}

      {skeleton ? (
        <div className={styles.skeletons}>
          <Skeleton
            roundness="round"
            className={styles.skeleton}
          />
          <Skeleton className={styles.skeleton} />
        </div>
      ) : (
        <label
          htmlFor={id}
          className={styles.switch}
        >
          <div className={styles.toggle} />
        </label>
      )}

      {children && !skeleton && (
        <label
          htmlFor={id}
          className={styles.children}
        >
          {children}
        </label>
      )}
    </div>
  );
};

export default Toggle;
export type { ToggleProps };
